// Which risks the RAID page's Risk Matrix and summary strip count.
//
// The list of items below them narrows with every filter on the page, but the
// matrix and the tiles are a picture of exposure for whatever you are looking
// at, so they follow the project scope (the SOW filter and its company-wide
// toggle) and the search box, and nothing else. Status is left alone because
// the tiles are themselves status counts and the matrix drops closed and
// transferred risks itself; the tag filter is about finding a row, not about
// what the exposure is.
//
// `sowFilter` takes the page's three shapes: 'all', 'company' (items with no
// project, plus any item ticked as company-wide / escalated) or a SOW id.
// `search` is the text in the "Search RAID items" box; empty means no narrowing.

// The one definition of what a search hits, shared by the list and the matrix
// so the two halves of the screen always agree: reference, title and
// description, case-insensitively.
export function matchesRaidSearch(item, search) {
  const q = (search || '').trim().toLowerCase();
  if (!q) return true;
  return `${item.reference || ''} ${item.title || ''} ${item.description || ''}`.toLowerCase().includes(q);
}

export function scopeRisksToSow(items, sowFilter, search) {
  return (items || []).filter(r => {
    if ((r.raid_type || 'risk') !== 'risk') return false;
    if (!matchesRaidSearch(r, search)) return false;
    if (sowFilter === 'all' || sowFilter == null || sowFilter === '') return true;
    if (sowFilter === 'company') return !r.sow_id || !!r.escalated;
    return r.sow_id === sowFilter;
  });
}
